module.exports = __webpack_public_path__ + "img/Content genaration & translation.bbc09a9d.png";